import WarningLoaderCircle from '@perpay-web/components/base/WarningLoaderCircle/WarningLoaderCircle';
import PhoExistingUserNotification from '@perpay-web/fintech/components/base/Notifications/PhoExistingUserNotification';
import CardApplicationContainer from '@perpay-web/fintech/components/containers/CardApplicationContainer';
import { useMountAndUnmount } from '@perpay-web/hooks/useMountAndUnmount';

const CardOnboardingSwitcher = ({
    onMount,
    onUnmount,
    isLoading,
    isPartnerOnboarded,
    ...rest
}) => {
    useMountAndUnmount(() => {
        onMount();
        return () => onUnmount();
    });

    if (isLoading) {
        return <WarningLoaderCircle />;
    }

    if (isPartnerOnboarded) {
        return <PhoExistingUserNotification />;
    }

    return <CardApplicationContainer {...rest} />;
};

export default CardOnboardingSwitcher;
